import { ApmRoutes } from '@elastic/apm-rum-react';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { NavigationService, useGTM, useVWO } from '../../common';
import { MainRouting } from './main.routes';

const MainRouter = () => {

  const RoutesWrapper = ({ children }: {
    children: React.ReactNode;
  }) => {

    const navigate = useNavigate();

    useGTM();
    useVWO();

    useEffect(() => {
      NavigationService.setNavigateFunction(navigate);
    }, [navigate])

    return <ApmRoutes>
      {children}
    </ApmRoutes>
  };

  return (
    <Router>
      <RoutesWrapper>
        {NavigationService.generateRoutes(MainRouting())}
      </RoutesWrapper>
    </Router>
  )
}

export default MainRouter;
